export const URLS = {
  AUTH_CASHBACK_REPORT: '/employeeDiscounts/cashbackReport',
  AUTH_CASHBACK_REPORT_EMPLOYEE: '/employeeDiscounts/cashbackReport/:id',
  AUTH_ELIGIBILITY_RULES: '/employeeDiscounts/eligibilityRules',
  AUTH_RULE_MANAGEMENT: '/employeeDiscounts/ruleManagement'
}

export const ALLOWED_SORT_FIELDS = new Set([
  "dateKey",
  "storeNo",
  "workstationId",
  "transactionSequenceNo",
])
